import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Mail, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/ai-solutions', label: 'AI Solutions' },
    { path: '/erp-platforms', label: 'ERP Platforms' },
    { path: '/industries', label: 'Industries' },
    { path: '/solutions', label: 'Solutions' },
    { path: '/partnerships', label: 'Partnerships' },
    { path: '/resources', label: 'Resources' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-sm border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4">
        {/* Top Bar */}
        <div className="hidden md:flex justify-end items-center py-2 text-sm border-b border-gray-100">
          <a href="mailto:info@geminitechlabs.com" className="flex items-center text-gray-600 hover:text-blue-600 transition-colors mr-6">
            <Mail className="h-4 w-4 mr-2" />
            info@geminitechlabs.com
          </a>
          <a href="tel:+918097080066" className="flex items-center text-gray-600 hover:text-blue-600 transition-colors">
            <Phone className="h-4 w-4 mr-2" />
            +91 8097080066
          </a>
        </div>

        {/* Main Navigation */}
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_tech-automation-8/artifacts/hbf6iyqa_ec386161-b3bf-46ae-aaf3-9b29a08d7178_removalai_preview.png" 
              alt="Gemini Tech Labs" 
              className="h-16 w-auto"
            />
            <span className="text-2xl font-bold text-gray-900">Gemini Tech Labs</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                  isActive(link.path)
                    ? 'text-blue-600 bg-blue-50'
                    : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <Link to="/contact">
              <Button className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white shadow-md hover:shadow-lg transition-all">
                Get Started
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                    isActive(link.path)
                      ? 'text-blue-600 bg-blue-50'
                      : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <div className="pt-4 border-t border-gray-200 mt-4">
                <a href="mailto:info@geminitechlabs.com" className="flex items-center text-gray-600 px-4 py-2 text-sm">
                  <Mail className="h-4 w-4 mr-2" />
                  info@geminitechlabs.com
                </a>
                <a href="tel:+918097080066" className="flex items-center text-gray-600 px-4 py-2 text-sm">
                  <Phone className="h-4 w-4 mr-2" />
                  +91 8097080066
                </a>
              </div>
              <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
                <Button className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white mt-4">
                  Get Started
                </Button>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;